
/*eslint-disable */

import { bus } from '@/main';
import deleteEventPopup from '../delete-event-data-popup/';
import { mapGetters } from 'vuex';

export default {
  name: 'events-list',
  components: {
    'delete-event-popup' : deleteEventPopup
  },
  props: [],
  data () {
    return {
      eventListData:null,
      eventListRslts:[],
      deleteEventPopupState:false,
      deleteEventId:''
    }
  },
  computed: {
    ...mapGetters([
      'eventListGetters',
    ]),
    getEventListFun(){
     this.eventListData = this.$store.getters.eventListGetters.data
     return 
    },
    setInintialState(){
      if(this.eventListData){
        this.eventListRslts = this.eventListData.data;
      }
      return;
    }
  },
  mounted () {
    this.getEventListFun
    this.setInintialState
    bus.$on('deleteEventPopupStateBus', (data) => {
      this.deleteEventPopupState = data
    })
  },
  methods: {
    deleteEventPopupMethod(evtId){
      this.deleteEventId = evtId
      this.deleteEventPopupState =  true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch: {
    getEventListFun(){
      return this.$store.getters.eventListGetters; 
    },
    setInintialState(){
      if(this.eventListData){
        this.eventListRslts = this.eventListData.data;
      }
      return;
    }
  },
}